import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const SvgIconAchievementAnalysisSad = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 26,
	height: 26,
	viewBox: "0 0 26 26",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M13 23.5001C18.799 23.5001 23.5 18.7991 23.5 13.0001C23.5 7.20104 18.799 2.5 13 2.5C7.20101 2.5 2.5 7.20104 2.5 13.0001C2.5 18.7991 7.20101 23.5001 13 23.5001Z",
			fill: "#FFD7D1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.9977 14.741C14.5204 14.741 15.971 15.3979 16.9771 16.5426C17.2974 16.9068 17.2617 17.461 16.8975 17.7813C16.5333 18.101 15.9791 18.0653 15.6588 17.7017C14.9855 16.9356 14.0158 16.4962 12.9977 16.4962C11.9797 16.4962 11.01 16.9356 10.3367 17.7017C10.017 18.0659 9.46222 18.1016 9.09801 17.7813C8.7338 17.4616 8.69807 16.9068 9.0184 16.5426C10.0251 15.3979 11.4751 14.741 12.9977 14.741Z",
			fill: "#FF705C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.93412 12.3971C10.7051 12.3971 11.3301 11.772 11.3301 11.001C11.3301 10.23 10.7051 9.60498 9.93412 9.60498C9.16311 9.60498 8.53809 10.23 8.53809 11.001C8.53809 11.772 9.16311 12.3971 9.93412 12.3971Z",
			fill: "#FF705C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.066 12.3971C16.837 12.3971 17.462 11.772 17.462 11.001C17.462 10.23 16.837 9.60498 16.066 9.60498C15.2949 9.60498 14.6699 10.23 14.6699 11.001C14.6699 11.772 15.2949 12.3971 16.066 12.3971Z",
			fill: "#FF705C"
		})
	]
});
export default SvgIconAchievementAnalysisSad;
